module.exports = __webpack_public_path__ + "static/img/title.6717c4ce.png";